var heading_default = {
  "fontElementMap": "_3VAiL",
  "elementSpacing": "nYVpd",
  "headerOne": "S3z9i nYVpd",
  "headerTwo": "fxP4f nYVpd",
  "headerThree": "zHVzV nYVpd",
  "headerFour": "KCZRD nYVpd",
  "headerFive": "_8kvXn nYVpd",
  "headerSix": "_2-Dx1 nYVpd",
  "child": "CWBiH"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
